export const showAmountWithFormatting = (num: number) => {
  const amount = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(Math.abs(num));

  return (
    <>
      {num < 0 && "-"}
      <i className="bi bi-currency-yen"></i>
      {amount}
    </>
  );
};

